export default __webpack_public_path__ + "static/media/photoMe.ed87cf4a.png";